export const DOMAIN_NOT_VERIFIED = 'Authentication pending';
export const DOMAIN_UNDER_APPROVAL = 'Under Approval';
export const DOMAIN_ACTIVE = 'Active';
export const DOMAIN_REJECTED = 'Domain not approved';
export const DOMAIN_EVALUATION = 'Domain assessment pending';
